export const URL = 'https://api.punkapi.com/v2/beers'

//Max QUANTITY - 25
export const QUANTITY_OF_BEER_IN_THE_CATALOG = 20